import styled, { css } from "styled-components";

export const StyledPromoModal = styled.div`
    margin: -24px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    background: #317f7f;
    img {
        width: 660px;
        height: 440.72px;
        display: block;
        ${p =>
            p.theme.xs(css`
                width: 100%;
                height: auto;
            `)}
    }
    ${p =>
        p.theme.xs(css`
            margin: -18px;
            background: white;
        `)}
`;

export const UI = styled.div`
    position: absolute;
    top: 1px;
    right: 13px;
    width: 300px;
    ${p =>
        p.theme.xs(css`
            position: static;
            width: auto;
            text-align: center;
        `)}
    h2 {
        font-variant: small-caps;
        color: ${p => p.theme.c.info};
        margin: 15px 0 6px;
        font-size: 22px;
        ${p =>
            p.theme.xs(css`
                color: ${p => p.theme.c.active};
            `)}
    }
    p {
        margin-top: 6px;
        color: ${p => p.theme.c.light};
        font-size: 16px;
        line-height: 1.4;
        ${p =>
            p.theme.xs(css`
                color: ${p => p.theme.c.boost};
                width: 300px;
                margin: 6px auto 12px;
            `)}
    }
    a {
        display: inline-block;
        width: 141px;
        font-size: 14px;
        text-align: center;
        /* stylelint-disable */
        &:first-of-type  {
            margin-right: 16px;
        }
        /* stylelint-enable */
        ${p =>
            p.theme.xs(css`
                display: block;
                margin: 0 auto 12px !important;
                width: calc(100% - 24px);
                max-width: 260px;
            `)}
    }
    ${p =>
        p.theme.sm.min(css`
            h2,
            p {
                text-shadow: 0 0 2px ${p => p.theme.c.blackShadow35};
            }
            .button {
                background-color: ${p => p.theme.c.info};
                color: #795548;
                margin-bottom: 14px;
            }

            .button--light {
                background-color: transparent;
                border-color: white;
                color: white;
                text-shadow: none;
                &:hover {
                    background-color: transparent;
                }
                &:focus {
                    border-color: ${p => p.theme.c.pale};
                }
            }
        `)}

    div {
        font-weight: 300;
        font-size: 15px;
        color: white;
        ${p =>
            p.theme.xs(css`
                color: ${p => p.theme.c.boost};
                margin-bottom: 11px;
                margin-top: -2px;
            `)}
    }

    .fullButtons a {
        width: 100%;
    }
`;
